import { isDefined } from '@app/utils/is';
import React from 'react';
import { PlacementType } from 'react-laag/dist/PlacementType';

import { Portal } from '../Portal';
import { Scrim } from '../Scrim';

import { DropdownContextProvider, useDropdownContext } from './context/DropdownContext';
import { DropdownDrawer } from './DropdownDrawer';
import { DropdownPopover } from './DropdownPopover';

interface Props {
  title?: React.ReactNode;
  shouldShowTitleInDropdown?: boolean;
  children: [React.ReactElement, React.ReactElement];
  placement?: PlacementType;
  onOpen?: () => void;
  onClose?: () => void;
}

const DropdownComponent = ({ children, title, shouldShowTitleInDropdown = false }: Props) => {
  const [menuTrigger, menu] = React.Children.toArray(children);

  const { layerProps, isDropdownOpen, activeParentItemKey, isMobile, closeDropdown } = useDropdownContext();

  return (
    <>
      {menuTrigger}
      {isMobile ?
        <Portal>
          <Scrim isVisible={isDropdownOpen} onClick={closeDropdown} />
          <DropdownDrawer title={title} isOpen={isDropdownOpen} isHidden={isDefined(activeParentItemKey)} onClose={closeDropdown}>
            {menu}
          </DropdownDrawer>
        </Portal>
      : layerProps.renderLayer(
          <DropdownPopover
            title={shouldShowTitleInDropdown ? title : undefined}
            isOpen={isDropdownOpen}
            {...layerProps.layerProps}
            onClose={closeDropdown}
          >
            {menu}
          </DropdownPopover>,
        )
      }
    </>
  );
};

export const Dropdown = ({ children, ...props }: Props) => {
  return (
    <DropdownContextProvider {...props}>
      <DropdownComponent {...props}>{children}</DropdownComponent>
    </DropdownContextProvider>
  );
};
